import { useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { setQueryParams } from "../../../utils";

export default function SearchBox({ className, type }) {

  const navigate = useNavigate()
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();

  const [value, setValue] = useState(searchParams.get('search'));

  const handleSearch = () => {
    try {
      if (pathname === '/all-products') {
        const queryString = setQueryParams({ search: value });
        navigate(`?${queryString}`, { replace: true });
      } else {
        navigate({
          pathname: '/all-products',
          search: `?search=${value}`,
        })
      }
    } catch (error) {
      console.log('handleSearch => error:', error)
    }
  }

  return (
    <>
      <div
        style={{ borderRadius: '30px', backgroundColor: '#f2f2f2' }}
        className={`w-full h-full flex items-center  border border-qgray-border bg-white ${className || ""}`} >
        {/* <div className="flex items-center px-4">
          <button
            type="button"
            className="w-full text-xs font-500 text-qgray flex justify-between items-center"
          >
            <span className="text-qgray">All Categories</span>
            <span>
              <svg
                width="10"
                height="5"
                viewBox="0 0 10 5"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="9.18359"
                  y="0.90918"
                  width="5.78538"
                  height="1.28564"
                  transform="rotate(135 9.18359 0.90918)"
                  fill="#8E8E8E"
                />
                <rect
                  x="5.08984"
                  y="5"
                  width="5.78538"
                  height="1.28564"
                  transform="rotate(-135 5.08984 5)"
                  fill="#8E8E8E"
                />
              </svg>
            </span>
          </button>
        </div>
        <div className="w-[1px] h-[22px]" style={{ backgroundColor: '#8E8E8E' }}></div> */}
        <div className="flex-1 h-full ml-3">
          <input
            type="text"
            className="search-input"
            placeholder="Search Product..."
            defaultValue={searchParams.get('search')}
            style={{ backgroundColor: '#f2f2f2' }}
            onChange={(e) => setValue(e.target.value)}
            onKeyDown={(e) => {
              if (e?.keyCode === 13)
                handleSearch()
            }}
          />
        </div>
        <button
          style={{ borderTopRightRadius: '30px', borderBottomRightRadius: '30px' }}
          className="bgcolor text-white lg:w-[130px] w-[64px] h-full text-sm font-600 flex items-center justify-center flex-shrink-0"
          type="button"
          onClick={() => handleSearch()}
        >
          <span className="hidden lg:inline">Search</span>
          <span className="lg:hidden">
            <svg width="18" height="18" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 8.83158C0.0484783 8.43809 0.0969566 8.04461 0.169674 7.67571C0.484783 5.92962 1.2362 4.42946 2.39968 3.12604C3.75707 1.60128 5.45381 0.592971 7.44142 0.199486C9.76838 -0.267779 11.9741 0.0765214 14.0345 1.33076C16.3614 2.75714 17.84 4.82294 18.3975 7.50356C18.8823 9.7907 18.5187 11.9795 17.4037 14.0453C17.1856 14.4388 17.1856 14.4388 17.5007 14.7585C19.1247 16.4062 20.7487 18.0539 22.3727 19.7016C22.906 20.2427 23.1242 20.8575 22.9302 21.5953C22.5667 22.9971 20.8457 23.5135 19.7549 22.3822C18.8338 21.4231 17.9127 20.5132 16.9674 19.5541C16.216 18.7917 15.4888 18.0539 14.7374 17.2915C14.6889 17.2423 14.6404 17.1932 14.6162 17.1686C14.0345 17.4637 13.5012 17.808 12.9195 18.0539C10.4228 19.1114 7.90196 19.0868 5.42957 17.9555C3.56316 17.0948 2.15728 15.7422 1.16348 13.9469C0.533261 12.791 0.145435 11.5614 0.0484783 10.2334C0.0484783 10.1596 0.0242392 10.0858 0 10.012C0 9.64314 0 9.22507 0 8.83158ZM3.00566 9.4464C3.00566 12.9632 5.84164 15.816 9.30784 15.816C12.774 15.7914 15.5615 12.9632 15.5858 9.4464C15.5858 5.95422 12.7498 3.07685 9.30784 3.07685C5.8174 3.07685 3.00566 5.92962 3.00566 9.4464Z" fill="white" />
            </svg>
          </span>
        </button>
      </div>
    </>
  );
}
